import { ActivityType } from 'modules/trainingLibrary/TrainingLibrary/types'

const base = `/${ActivityType.TrainingVideos}`

const routes = {
  root: `${base}/details`,
}

export default routes
